import { IPayoutSettingsResponse } from "@wingspanhq/payments/dist/interfaces";

export const selectorDefaultDestination = (
  payoutSettings: IPayoutSettingsResponse
) =>
  payoutSettings.payoutDestinations.find(
    destination => destination.payoutMethod === payoutSettings.payoutPreferences
  );
